import { MailerService } from './../../../../../../services/shared/mailer.service';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Solicitud } from '../../../../../../interfaces/interface-bakend/ofertas-laborales/solicitudes.interface';
import { SolicitudesService } from '../../../../../../services/ofertas-laborales/solicitudes.service';
import { User } from '../../../../../../interfaces/interface-bakend/seguridad/users/user.interface';
import { ActividadesService } from '../../../../../../services/ofertas-laborales/actividades.service';
import {
    MatDialog,
    MatDialogRef,
    MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { UploadFileSolicitudComponent } from '../../../../common/upload-file-solicitud/upload-file-solicitud.component';
import { OfertasImageViewerComponent } from '../../../../common/ofertas-image-viewer/ofertas-image-viewer.component';
import { MediaService } from '../../../../../../services/shared/media.service';
import { CatalogoService } from '../../../../../../services/shared/catalogo.service';
import { GuiMsjService } from '../../../../../../services/shared/gui-msj.service';
import { Actividad } from '../../../../../../interfaces/interface-bakend/ofertas-laborales/actividad.interface';
import {
    APP_CONFIG_OFERTAS,
    IAppOfertas,
} from '../../../../../../app.config/app.config-ofertas';
import { Subscription } from 'rxjs';
import { UserEntreUser } from '@interfaces/interface-bakend/seguridad/users/user-entre-user.interface';
import { UserEntreUserService } from '@services/shared/user-entre-user.service';
import Swal from 'sweetalert2';
import { GecrosAfiliadosService } from '@services/entidades/gecros-afiliados.service';
import { AuthService } from '@services/auth/auth.service';
import { UsuarioService } from '@services/shared/usuario.service';
import { environment } from '@env/environment';
import { SignoPlanService } from '@services/entidades/signo-planes.service';
import { SignoSedeService } from '@services/entidades/signo-sedes.service';
import { PdfExportService } from 'src/app/services/shared/pdf-export.service';

//// Interfaces Inscripcion y DDJJ
import {
    InscripcionOs,
    Familiar,
    Parentesco,
    Nacionalidad,
    Sexo,
    RegimenLaboral,
    TipoDocumento,
    EstadoCivil,
} from 'src/app/auth/inscripcion-os/interfaz-inscripcion-os/inscripcion-os-interface';
import {
    DeclaracionJurada
} from 'src/app/auth/inscripcion-os/interfaz-ddjj-os/ddjj-os-interface';

interface DdjjItem {
    label: string;
    tipo: 'siNo' | 'texto' | 'grupo';
    tiene?: boolean;
    valor?: string;
    hijos?: DdjjItem[];
}

interface DdjjSeccion {
    titulo: string;
    items: DdjjItem[];
}

@Component({
    selector: 'app-bandeja-inscripciones',
    templateUrl: './bandeja-inscripciones.component.html',
    styleUrls: ['./bandeja-inscripciones.component.scss'],
})
export class BandejaInscripcionesComponent implements OnInit, OnDestroy {
    // Estados
    activarEnRevision: boolean = false;
    activarEnAuditoria: boolean = false;
    activarAprobar: boolean = false;
    activarRechazar: boolean = false;
    activarEnvio: boolean = false;
    activarCerrarModal: boolean = true;
    activarEnEspera: boolean = true;
    activarDeshacerAnulacion: boolean = false;

    flagDisableButtonApprove: boolean = true;
    flagCargaCorrecta: boolean = false;
    selectedFile: File;
    selectedFileName: string = '';
    value: number = 0;
    isActive: boolean = false;
    subscriptionAvance: Subscription;

    motivoRevision: string = '';
    motivoRechazo: string = '';
    motivoEnEspera: string = '';
    nombrePais: string;
    actividad: Actividad;
    solicitud: Solicitud;
    beneficiario: UserEntreUser;
    usuario: User;

    flagLoaded: boolean;
    flagSpinner: boolean = false;
    exportandoPDFs = false;
    exportandoPDFsMensaje = '';
    flagEnRevision: boolean = false;
    flagEnAuditoria: boolean = false;
    flagLabelAprobado: boolean = false;
    flagLabelRechazado: boolean = false;
    flagLabelPresentado: boolean = false;
    flagLabelEnEspera: boolean = false;
    flagLabelCompleta: boolean = false;

    isCheckedAprobar: boolean = false;
    isCheckedRechazar: boolean = false;
    isCheckedEnRevision: boolean = false;
    isCheckedEnviarDocumentos: boolean = false;
    isCheckedEnEspera: boolean = false;

    dataModal: any;

    estadoDocumentacion: string;

    imgs: string[] = [];
    files: string[] = [];
    nombresImagenes: { [key: string]: string } = {};

    adjuntoCatalogo: any;
    idioma: Subscription;
    newState: Subscription;

    habilitarEnviarObservacion: boolean = false;
    // Flags separados por acción (antes estaban compartidos: Anular/En espera
    // se habilitaban cruzados al tipear en cualquiera).
    habilitarEnviarEspera: boolean = false;
    habilitarEnviarAnulacion: boolean = false;
    botonAuditoriaHabilitado: boolean = false;
    mostrarLeyenda: boolean = false;

    observacionEmailAuditoriaMedica: string = '';
    observacionInterna: string = '';

    selectedFiles: any[] = [];

    verificacionGecrosModal: boolean = false;
    resultadosGecros: any[] = [];
    todosEnGecros: boolean = false;

    esSedeInscripcion: boolean = true;

    verificacionGecrosRealizada: boolean = false;
    searchTerm: string = '';
    searchResults: any[] = [];
    currentSearchIndex: number = -1;
    searchableElements: any[] = [];

    habilitarGuardarObservacionInterna: boolean = false;
    /** DNIs de familiares excluidos de la aprobación (no se registran ni notifican). */
    familiaresOmitidos: string[] = [];

    datosInscripcionCompleta: any = null;

    // Mapa de etiquetas para secciones médicas
    fieldLabelMap: Record<string, string> = {
        // Síntomas y experiencias
        doloresCabeza: 'Dolores de cabeza',
        trastornosOculares: 'Trastornos oculares',
        mareosDesmayos: 'Mareos/desmayos',
        convulsiones: 'Convulsiones',
        neuralgiaNeuritis: 'Neuralgia/neuritis',
        depresion: 'Depresión',
        supuracionOidos: 'Supuración de oídos',
        resfriosFrecuentes: 'Resfríos frecuentes',
        tosCronica: 'Tos crónica',
        sudoresNocturnos: 'Sudores nocturnos',
        perdidaPeso: 'Pérdida de peso',
        doloresPecho: 'Dolores en el pecho',
        temblores: 'Temblores',
        debilidadMuscular: 'Debilidad muscular',
        faltaAire: 'Falta de aire',
        palpitaciones: 'Palpitaciones',
        acidez: 'Acidez',
        dificultadOrinar: 'Dificultad para orinar',
        sangreOrina: 'Sangre en la orina',
        articulacionesHinchadas: 'Articulaciones hinchadas',
        lumbalgia: 'Lumbalgia',
        ciatalgia: 'Ciatalgia',
        desviacionColumna: 'Desviación de columna',
        fracturas: 'Fracturas',
        traumatismos: 'Traumatismos',
        cirugias: 'Cirugías',
        internaciones: 'Internaciones',
        otros: 'Otros',

        // Antecedentes familiares
        artritisFamiliar: 'Artritis familiar',
        enfermedadesInmunologicas: 'Enfermedades inmunológicas',
        cancer: 'Cáncer',
        enfermedadCardiaca: 'Enfermedad cardíaca',
        tensionAlta: 'Tensión alta',
        enfermedadRenal: 'Enfermedad renal',
        tuberculosis: 'Tuberculosis',
        enfermedadesMentales: 'Enfermedades mentales',
        enfermedadesHereditariasGeneticas: 'Enf. hereditarias genéticas',

        // Antecedentes patológicos
        diabetes: 'Diabetes',
        hipertension: 'Hipertensión',
        alergia: 'Alergia',
        asma: 'Asma',
        calculosRenales: 'Cálculos renales',
        infeccionUrinaria: 'Infección urinaria',
        hepatitis: 'Hepatitis',
        chagas: 'Chagas',
        brucelosis: 'Brucelosis',
        toxoplasmosis: 'Toxoplasmosis',
        trastornosPsiquiatricos: 'Trastornos psiquiátricos',
        trastornosMarcha: 'Trastornos de la marcha',
        dispositivosMedicos: 'Dispositivos médicos',
        enfermedadesTransmisionSexual: 'Enf. transmisión sexual',
        alteracionesEndocrinas: 'Alteraciones endocrinas',
        artritis: 'Artritis',
        enfermedadesPiel: 'Enfermedades de la piel',
        epilepsia: 'Epilepsia',
        ulceraGastrica: 'Úlcera gástrica',
        gastritis: 'Gastritis',
        hemorroides: 'Hemorroides',
        hernias: 'Hernias',
        sinusitis: 'Sinusitis',
        cancerTumores: 'Cáncer/tumores',
        varices: 'Várices',
        discapacidad: 'Discapacidad',
        incapacidad: 'Incapacidad',
        medicoEspecialTraslado: 'Médico especial/traslado',

        // Antecedentes quirúrgicos
        traumatologica: 'Traumatológica',
        cardiaca: 'Cardíaca',
        ginecologica: 'Ginecológica',
        general: 'General',
        neuroquirurgicas: 'Neuroquirúrgicas',
        malformacionesNacimiento: 'Malformaciones de nacimiento',
        hidrocefalia: 'Hidrocefalia',
        malformacionesGeneticas: 'Malformaciones genéticas',

        // Gineco-obstétricos (subclaves)
        alteracionesMenstruales: 'Alteraciones menstruales',
        embarazos: 'Embarazos',
        patologiaMamaria: 'Patología mamaria',
    };

    constructor(
        @Inject(APP_CONFIG_OFERTAS) private iAppOfertas: IAppOfertas,
        @Inject(MAT_DIALOG_DATA) public data: string,
        public dialogRef: MatDialogRef<BandejaInscripcionesComponent>,
        private router: Router,
        private solicitudesService: SolicitudesService,
        private mediaService: MediaService,
        public dialog: MatDialog,
        private mailerService: MailerService,
        private catalogoService: CatalogoService,
        private guiMsjService: GuiMsjService,
        private userEntreUserService: UserEntreUserService,
        private gecrosAfiliadosService: GecrosAfiliadosService,
        private authService: AuthService,
        private usuarioService: UsuarioService,
        private signoPlanService: SignoPlanService,
        private signoSedeService: SignoSedeService,
        private actividadesService: ActividadesService,
        private pdfExportService: PdfExportService,
    ) {
        this.newState = this.solicitudesService
            .getsetNewStater()
            .subscribe((resp) => {
                this.initPostChangeStatus();
                this.newState = resp;
            });
        this.mediaService.reiniciarContadorControlUpload();
        this.subscribeAvanceUpload();
    }

    ngOnInit(): void {
        this.getDataSolicitud();
        this.cargarAdjuntoContrato();
    }

    ngOnDestroy(): void {}

    initPostChangeStatus(): void {
        this.getDataSolicitud();
        this.activarCerrarModal = true;
    }

    clearSelectionFile() {
        this.selectedFile = null;
        this.selectedFileName = '';
        this.isActive = false;
    }

    subscribeAvanceUpload() {
        this.subscriptionAvance = this.mediaService
            .getAvance()
            .subscribe((resp) => {
                if (resp) {
                    this.value = resp.value;
                } else {
                    this.value = 0;
                }
            });
    }

    async getDataSolicitud() {
        console.log(await this.getSolicitud());
        this.flagLoaded = false;
        await this.getEstadoSolicitud(await this.getSolicitud());
        await this.getArrayImgsAndFile((await this.getSolicitud()).adjuntos);
        await this.setNombresAdjuntos();
        await this.getBeneficiario(this.solicitud);
        this.observacionInterna = this.solicitud?.observacionInterna || '';
        this.habilitarBotonObservacionesInternas(this.observacionInterna);

        // Asignar datos completos de inscripción y DDJJ para los paneles
        this.datosInscripcionCompleta = {
            ...(this.solicitud.inscripcion?.contenido || {}),
            ddjj: this.solicitud.ddjj?.contenido || null
        };

        this.flagLoaded = true;
    }

    async getSolicitud(): Promise<Solicitud> {
        this.solicitud =
            await this.solicitudesService.getSolicitudSeleccionada();
        this.actividad = this.solicitud.actividad;
        this.usuario = this.solicitud.usuario;
        this.nombrePais = this.solicitud.pais.name_es;
        this.esSedeInscripcion = true;
        console.log('solicitud', this.solicitud);
        return this.solicitud;
    }

    async getBeneficiario(solicitud: Solicitud) {
        this.beneficiario =
            await this.userEntreUserService.getBeneficiario(solicitud);
    }

    async getEstadoSolicitud(solicitud: Solicitud) {
        this.activarEnEspera = true;

        console.log(
            'solicitud.lastState.numberState',
            solicitud.lastState.numberState,
        );

        switch (solicitud.lastState.numberState) {
            case 0: // PRESENTADO
                this.activarRechazar = false;
                this.activarEnRevision = true;
                this.activarEnAuditoria = false;
                this.activarAprobar = true;
                this.activarRechazar = true;
                this.flagLabelPresentado = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.pendiente;
                break;

            case 1: // DOCUMENTACION PRESENTADA
                this.activarEnAuditoria = true;
                this.activarAprobar = true;
                this.activarEnRevision = true;
                this.activarRechazar = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.pendiente;
                break;

            case 2: // EN REVISIÓN
                this.flagEnRevision = true;
                this.activarEnRevision = true;
                this.activarRechazar = true;
                this.activarEnAuditoria = true;
                this.activarAprobar = true;
                this.activarRechazar = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                break;

            case 3: // EN AUDITORIA MÉDICA
                this.activarEnRevision = false;
                this.activarRechazar = true;
                this.activarEnAuditoria = true;
                this.activarAprobar = true;
                this.activarRechazar = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                this.flagEnAuditoria = true;
                break;

            case 4: // APROBADA
                this.activarEnRevision = false;
                this.activarAprobar = false;
                this.activarEnAuditoria = false;
                this.flagLabelAprobado = true;
                this.activarRechazar = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                break;

            case 5: // RECHAZADO/ANULADO
                this.activarRechazar = false;
                this.flagLabelRechazado = true;
                this.activarEnEspera = false;
                this.activarDeshacerAnulacion = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                break;

            case 6: // EN ESPERA
                this.activarEnEspera = false;
                this.activarEnRevision = true;
                this.activarRechazar = true;
                this.activarEnAuditoria = true;
                this.activarAprobar = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                this.flagLabelEnEspera = true;
                this.flagEnRevision = false;
                break;

            case 14: // INSCRIPCION PARCIAL
                this.activarEnRevision = true;
                this.activarRechazar = true;
                this.activarEnAuditoria = false;
                this.activarAprobar = true;
                this.activarEnEspera = true;
                this.flagLabelPresentado = false;
                this.flagLabelEnEspera = false;
                this.flagLabelAprobado = false;
                this.flagLabelRechazado = false;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.pendiente;
                break;

            case 15: // INSCRIPCION COMPLETA (DDJJ)
                this.activarEnRevision = true;
                this.activarRechazar = true;
                this.activarEnAuditoria = false;
                this.activarAprobar = true;
                this.activarEnEspera = true;
                this.flagLabelPresentado = false;
                this.flagLabelEnEspera = false;
                this.flagLabelAprobado = false;
                this.flagLabelRechazado = false;
                this.flagLabelCompleta = true;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                break;

            case 16: // INSCRIPCION APROBADA
                this.activarEnRevision = false;
                this.activarRechazar = false;
                this.activarEnAuditoria = false;
                this.activarAprobar = false;
                this.activarEnEspera = false;
                this.flagLabelAprobado = true;
                this.flagLabelPresentado = false;
                this.flagLabelEnEspera = false;
                this.flagLabelRechazado = false;
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.completo;
                break;

            default:
                this.estadoDocumentacion =
                    this.iAppOfertas.documentacion.pendiente;
                break;
        }
    }

    async getArrayImgsAndFile(adjuntos: string[]) {
        console.log('Adjuntos recibidos:', adjuntos);
        this.imgs = [];
        this.files = [];
        adjuntos.forEach((element) => {
            if (element.toLowerCase().includes('.pdf')) {
                this.files.push(element);
            } else {
                this.imgs.push(element);
            }
        });
        console.log('Imagenes:', this.imgs, 'Archivos:', this.files);
    }

    verImagen(img: string) {
        const imagenes = this.imgs.map((i) => ({
            url: `${environment.urlBackend}/media/imgUserOffer/${this.usuario._id}/${i}`,
            titulo: this.nombresImagenes[i] || 'Visualización de Imagen',
        }));
        const index = this.imgs.indexOf(img);
        this.dialog.open(OfertasImageViewerComponent, {
            data: { imagenes, index: index < 0 ? 0 : index },
            width: 'min(1100px, 94vw)',
            maxWidth: '94vw',
            maxHeight: '92vh',
            panelClass: 'ds-dialog'
        });
    }

    descargarImagenPDF(img: string) {
        const url = `${environment.urlBackend}/media/image-pdf/${this.usuario._id}/${img}`;
        window.open(url, '_blank');
    }

    async setNombresAdjuntos() {
        if (!this.imgs || this.imgs.length === 0) return;

        for (const img of this.imgs) {
            try {
                if (!img) continue;

                if (img === 'ADJUNTO_CONTRATO') {
                    this.nombresImagenes[img] = 'Adjunto Contrato';
                    continue;
                }

                const idAdjunto = img.includes('.') ? img.split('.')[0] : img;
                const docEncontrado = this.solicitud?.documentosEstadosSolicitar?.find(
                    (doc) => doc.documento?._id === idAdjunto
                );

                if (docEncontrado && docEncontrado.documento) {
                    this.nombresImagenes[img] = docEncontrado.documento.nombre;
                    continue;
                }

                let nombre = await this.actividadesService.getNombreAdjunto(img);
                if (!nombre) {
                    nombre = await this.usuarioService.getNombreAdjunto(img);
                }

                if (!nombre || idAdjunto === this.solicitud?._id) {
                    this.nombresImagenes[img] = 'Documento Extra';
                } else {
                    this.nombresImagenes[img] = nombre;
                }
            } catch (error) {
                console.error('Error resolviendo nombre para:', img, error);
                this.nombresImagenes[img] = 'Documento Extra';
            }
        }
    }

    async cargarAdjuntoContrato() {
        this.adjuntoCatalogo =
            await this.catalogoService.getFindByKey('ADJUNTO_CONTRATO');
    }

    openDialog(label: string, estado: string, idAdjunto: string): void {
        const dialogRef = this.dialog.open(UploadFileSolicitudComponent, {
            width: '800px',
            height: '800px',
            disableClose: true,
            data: {
                solicitud: this.solicitud,
                adjunto: idAdjunto,
                label,
                numberState: estado,
                labelButton: 'ENVIAR CONTRATO',
                accept: 'application/pdf',
            },
        });

        dialogRef.afterClosed().subscribe(async (result) => {
            if (result) {
                await this.refreshComponent('autorizaciones-listado');
                const messageDto = await this.mailerService.prepareMailToSend(
                    this.solicitud.usuario,
                    await this.getSolicitud(),
                    true,
                    this.adjuntoCatalogo.properties._idAdjunto,
                    'TEMPLATE_MAILER_CONTRATO',
                );
                await this.mailerService.sendMail(messageDto);
                this.dataModal = result;
            }
        });
    }

    refreshComponent(url) {
        this.router
            .navigateByUrl(url, { skipLocationChange: true })
            .then(async () => {
                await this.closeModal();
                await this.openDialogModaSolicitud();
            });
    }

    openDialogModaSolicitud(): void {
        const dialogRef = this.dialog.open(BandejaInscripcionesComponent, {
            width: '900px',
            height: '1000px',
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe(async (result) => {});
        return;
    }

    closeModal(): void {
        this.dialogRef.close();
    }

    async desactivarBotones() {
        this.activarEnRevision = false;
        this.activarEnAuditoria = false;
        this.activarRechazar = false;
        this.activarAprobar = false;
        this.activarCerrarModal = false;
        this.isCheckedAprobar = false;
        this.isCheckedRechazar = false;
        this.isCheckedEnRevision = false;
        this.activarEnEspera = false;
        this.isCheckedEnEspera = false;
    }

    async limpiarTexto() {
        this.motivoRevision = '';
        this.motivoRechazo = '';
        this.motivoEnEspera = '';
    }

    async habilitarBotonObservaciones(motivo: string) {
        this.habilitarEnviarObservacion = motivo.trim() !== '';
    }

    async habilitarBotonEspera(motivo: string) {
        this.habilitarEnviarEspera = motivo.trim() !== '';
    }

    async habilitarBotonAnulacion(motivo: string) {
        this.habilitarEnviarAnulacion = motivo.trim() !== '';
    }

    async actualizarEstadoSolicitud(
        _id: string,
        numberState: number,
        notificaAdmin: boolean,
        state?: string,
        notificar?: boolean,
        observaciones?: string,
        file?: string,
    ) {
        console.log(
            'Actualizando estado a:',
            numberState,
            'Nombre estado:',
            state,
        );
        console.log('Motivo proporcionado:', observaciones);

        await this.desactivarBotones();
        await this.limpiarTexto();
        this.activarDeshacerAnulacion = false;
        this.flagSpinner = true;

        this.solicitudesService
            .updateSolicitudState(
                _id,
                numberState,
                notificaAdmin,
                state,
                notificar,
                observaciones,
                file,
            )
            .then(async (solicitudUpdated: Solicitud) => {
                await this.solicitudesService.setSolicitudSeleccionada(
                    solicitudUpdated,
                );
                this.flagSpinner = false;
                this.solicitudesService.setNewState(solicitudUpdated);
                this.guiMsjService.msjFormSubmit('solicitudEstadoOK');
            })
            .catch((error) => {
                console.log(error);
            });
    }

    async deshacerAnulacion() {
        await this.actualizarEstadoSolicitud(
            this.solicitud._id,
            this.iAppOfertas.estado_2.number,
            false,
            this.iAppOfertas.estado_2.name,
            true,
            'Anulación revertida - La solicitud vuelve a revisión',
        );
    }

    get historialConUsuario(): any[] {
        // En inscripción los estados los crea el sistema (sin userName), así que
        // no se exige userName: se muestran todos salvo los internos 0/1.
        return this.solicitud?.states
            ? this.solicitud.states.filter(
                  (s) => s.numberState !== 0 && s.numberState !== 1,
              )
            : [];
    }

    // ---------- Métodos específicos de inscripción ----------
    async aprobarSolicitudInscripcion(): Promise<void> {
        console.log('Iniciando aprobación de inscripción');

        if (this.solicitud.signoSede?._id === '689e41b9bf64830c3ec6a613') {
            await this.verificarAfiliadosEnGecros();
            this.mostrarModalResultadosGecros();
            return;
        } else {
            this.flagSpinner = true;
            const currentState = this.solicitud.lastState.numberState;
            const nextState = currentState === 14 || currentState === 15 ? 16 : 4;
            const nextStateName =
                nextState === 16
                    ? this.iAppOfertas.estado_16.name
                    : this.iAppOfertas.estado_4.name;
            await this.actualizarEstadoSolicitud(
                this.solicitud._id,
                nextState,
                false,
                nextStateName,
                true,
                'Inscripción APROBADA - Proceso completado',
            );
            Swal.close();
            this.dialogRef.close(true);
        }
    }

    async verificarAfiliadosEnGecros(): Promise<boolean> {
        this.guiMsjService.msjFormSubmit('Guardando');
        this.resultadosGecros = [];
        this.familiaresOmitidos = [];
        const personas = this.obtenerPersonasDeSolicitud();
        for (const persona of personas) {
            const resultado = await this.verificarPersonaEnGecros(persona);
            this.resultadosGecros.push(resultado);
        }
        this.todosEnGecros = this.resultadosGecros.every((r) => r.enGecros);
        Swal.close();
        return this.todosEnGecros;
    }

    obtenerPersonasDeSolicitud(): any[] {
        const personas = [];
        const contenido = this.solicitud.inscripcion?.contenido as any;
        if (contenido?.datosDelTitular) {
            const titular = contenido.datosDelTitular;
            personas.push({
                tipo: 'Titular',
                apellido: titular.apellido,
                nombre: titular.nombre,
                dni: titular.numeroDocumento,
            });
        }
        if (contenido?.familiares) {
            contenido.familiares.forEach((familiar: any, index: number) => {
                personas.push({
                    tipo: 'Familiar',
                    apellido: familiar.apellido,
                    nombre: familiar.nombre,
                    dni: familiar.numeroDocumento,
                });
            });
        }
        return personas;
    }

    async verificarPersonaEnGecros(persona: any): Promise<any> {
        try {
            const resultadoGecros =
                await this.gecrosAfiliadosService.getAfiliadoByIdentificacion(
                    persona.dni,
                );
            const afiliados = resultadoGecros?.data || [];
            const datos = afiliados.length > 0 ? afiliados[0] : null;
            const existeEnGecros =
                afiliados.length > 0 && datos?.documento !== undefined;
            const sexo = datos?.sexo;
            const sinGenero =
                existeEnGecros &&
                (sexo === null ||
                    sexo === undefined ||
                    String(sexo).trim() === '');
            return {
                ...persona,
                enGecros: existeEnGecros,
                sinGenero,
                sexo: sexo ?? null,
                datosGecros: resultadoGecros,
            };
        } catch (error) {
            return {
                ...persona,
                enGecros: false,
                sinGenero: false,
                error: true,
            };
        }
    }

    /** Una persona es válida si GECROS la devuelve, trae género y no hubo error. */
    esPersonaValida(persona: any): boolean {
        return !!persona?.enGecros && !persona?.error && !persona?.sinGenero;
    }

    get titularGecros(): any {
        return this.resultadosGecros.find((r) => r.tipo === 'Titular');
    }

    get titularValido(): boolean {
        return this.esPersonaValida(this.titularGecros);
    }

    /** Motivo por el que el titular no se puede aprobar (vacío si es válido). */
    get titularMotivo(): string {
        const t = this.titularGecros;
        if (!t) {
            return 'No se pudo verificar al titular.';
        }
        if (t.error) {
            return 'No se pudo consultar GECROS para el titular.';
        }
        if (t.sinGenero) {
            return 'El titular figura en GECROS pero sin género.';
        }
        if (!t.enGecros) {
            return 'El titular no figura en GECROS.';
        }
        return '';
    }

    get familiaresGecros(): any[] {
        return this.resultadosGecros.filter((r) => r.tipo === 'Familiar');
    }

    familiarOmitido(dni: any): boolean {
        return this.familiaresOmitidos.includes(String(dni));
    }

    toggleOmitirFamiliar(persona: any): void {
        const dni = String(persona?.dni);
        if (this.familiarOmitido(dni)) {
            this.familiaresOmitidos = this.familiaresOmitidos.filter(
                (d) => d !== dni,
            );
        } else {
            this.familiaresOmitidos = [...this.familiaresOmitidos, dni];
        }
    }

    /** Familiares que no pasaron la verificación y todavía NO fueron omitidos. */
    get familiaresInvalidosSinOmitir(): any[] {
        return this.familiaresGecros.filter(
            (p) => !this.esPersonaValida(p) && !this.familiarOmitido(p.dni),
        );
    }

    get cantidadOmitidos(): number {
        return this.familiaresGecros.filter((p) =>
            this.familiarOmitido(p.dni),
        ).length;
    }

    /** Personas que efectivamente se van a procesar al aprobar. */
    get personasAProcesar(): any[] {
        return this.resultadosGecros.filter((p) =>
            p.tipo === 'Titular'
                ? this.esPersonaValida(p)
                : this.esPersonaValida(p) && !this.familiarOmitido(p.dni),
        );
    }

    /** Se puede aprobar si el titular es válido y no quedan familiares inválidos sin omitir. */
    get puedeConfirmarAprobacion(): boolean {
        if (this.resultadosGecros.length === 0) {
            return false;
        }
        if (!this.titularValido) {
            return false;
        }
        return this.familiaresInvalidosSinOmitir.length === 0;
    }

    mostrarModalResultadosGecros(): void {
        this.verificacionGecrosModal = true;
    }

    async confirmarAprobacion(): Promise<void> {
        try {
            this.flagSpinner = true;
            await this.asignarSedeATitular();
            await this.actualizarEmailVerificado(this.usuario._id);
            await this.darDeAltaFamiliares();

            const currentState = this.solicitud.lastState.numberState;
            const nextState = currentState === 14 || currentState === 15 ? 16 : 4;
            const nextStateName = nextState === 16
                ? this.iAppOfertas.estado_16.name
                : this.iAppOfertas.estado_4.name;

            let observaciones = 'Inscripción APROBADA - Proceso completado';
            const omitidos = this.familiaresGecros.filter((p) =>
                this.familiarOmitido(p.dni),
            );
            if (omitidos.length) {
                const detalle = omitidos
                    .map((p) => `${p.apellido}, ${p.nombre} (DNI ${p.dni})`)
                    .join('; ');
                observaciones += ` | Familiares omitidos (no válidos en GECROS): ${detalle}`;
            }

            await this.actualizarEstadoSolicitud(
                this.solicitud._id,
                nextState,
                false,
                nextStateName,
                true,
                observaciones,
            );
            await this.notificarAprobadosPostRegistro();
            Swal.close();
            this.dialogRef.close(true);
        } catch (error) {
            console.error('Error en confirmarAprobacion:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un problema al procesar la aprobación. Por favor, intente nuevamente.',
            });
        } finally {
            this.flagSpinner = false;
            this.verificacionGecrosModal = false;
            this.familiaresOmitidos = [];
        }
    }

    private async darDeAltaFamiliares(): Promise<void> {
        try {
            const contenidoInscripcion = this.solicitud.inscripcion
                ?.contenido as any;
            const familiares = contenidoInscripcion?.familiares;
            if (!familiares || familiares.length === 0) return;

            for (const familiar of familiares) {
                if (this.familiarOmitido(familiar.numeroDocumento)) {
                    console.warn(
                        `Familiar OMITIDO en la aprobación: ${familiar.nombre} ${familiar.apellido} (DNI ${familiar.numeroDocumento})`,
                    );
                    continue;
                }
                try {
                    await this.procesarFamiliar(familiar);
                } catch (error) {
                    console.error(
                        `Error procesando familiar ${familiar.nombre} ${familiar.apellido}:`,
                        error,
                    );
                }
            }
        } catch (error) {
            console.error('Error en darDeAltaFamiliares:', error);
            throw error;
        }
    }

    private async procesarFamiliar(familiar: Familiar): Promise<boolean> {
        try {
            const parentescoString = this.mapearParentesco(familiar.parentesco);
            const esMayorEdad = this.esMayorDeEdad(familiar.fechaNacimiento);

            const resultadoGecros = this.resultadosGecros.find(
                (r) => r.dni === familiar.numeroDocumento.toString() && r.tipo === 'Familiar',
            );

            let datosGecros = null;
            let codigoSedeFamiliar: string = null;

            if (resultadoGecros?.enGecros && resultadoGecros.datosGecros?.data?.length > 0) {
                datosGecros = resultadoGecros.datosGecros.data[0];
                const numeroAfiliado = datosGecros.numeroAfiliado;
                if (numeroAfiliado && numeroAfiliado.length >= 3) {
                    codigoSedeFamiliar = numeroAfiliado.substring(0, 3);
                }
            }

            let emailFinal = familiar.email;
            if (!esMayorEdad) {
                const nombre = datosGecros?.nombreAfiliado?.split(' ')[0] || familiar.nombre;
                const apellido = datosGecros?.nombreAfiliado?.split(' ').slice(1).join(' ') || familiar.apellido;
                const primeraLetraNombre = nombre.charAt(0).toLowerCase();
                emailFinal = `${familiar.numeroDocumento}@${primeraLetraNombre}${apellido.toLowerCase().replace(/\s+/g, '')}.ar`;
            }

            const notifica = esMayorEdad && this.esEmailValido(emailFinal);
            const datosRegistro = await this.prepararDatosRegistro(
                familiar,
                emailFinal,
                notifica,
                datosGecros,
                codigoSedeFamiliar,
            );

            const resultadoRegistro = await this.authService.registerUser(datosRegistro);
            if (resultadoRegistro) {
                const usuarioFamiliar = await this.usuarioService.getFindOneByIdentification(
                    familiar.numeroDocumento.toString(),
                );
                if (usuarioFamiliar) {
                    await this.actualizarEmailVerificado(usuarioFamiliar._id);
                    const relacion: UserEntreUser = {
                        titular: this.usuario,
                        adicional: usuarioFamiliar,
                        parentesco: parentescoString,
                    };
                    await this.userEntreUserService.createUserEntreUserInscripcionOs(relacion, false);
                    return true;
                }
            }
            return false;
        } catch (error) {
            console.error(`Error en procesarFamiliar para ${familiar.nombre}:`, error);
            return false;
        }
    }

    private mapearParentesco(parentesco: Parentesco): string {
        switch (parentesco) {
            case Parentesco.Esposo: return 'Esposo/a';
            case Parentesco.Concubino: return 'concubino/a';
            case Parentesco.Hijo: return 'HIJO/A';
        }
    }

    private esMayorDeEdad(fechaNacimiento: Date): boolean {
        const hoy = new Date();
        const nacimiento = new Date(fechaNacimiento);
        const edad = hoy.getFullYear() - nacimiento.getFullYear();
        const mes = hoy.getMonth() - nacimiento.getMonth();
        return mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())
            ? edad - 1 >= 18
            : edad >= 18;
    }

    private async prepararDatosRegistro(
        familiar: Familiar,
        email: string,
        notifica: boolean,
        datosGecros: any,
        codigoSede: string,
    ): Promise<any> {
        return {
            email: email,
            emailConfirm: email,
            password: familiar.numeroDocumento.toString(),
            passwordConfirm: familiar.numeroDocumento.toString(),
            nombrePersona: datosGecros?.nombreAfiliado?.split(' ')[0] || familiar.nombre,
            apellidoPersona: datosGecros?.nombreAfiliado?.split(' ').slice(1).join(' ') || familiar.apellido,
            tipoIdentificacion: '6272eb83577d4b3218ec6ba6',
            identificacion: familiar.numeroDocumento.toString(),
            aceptaTerminos: true,
            proteccionDeDatos: true,
            clausula: true,
            fromWeb: true,
            fromApp: false,
            signoGecrosAfiliado: datosGecros,
            signoPlan: datosGecros?.plan || null,
            codigoGecros: codigoSede,
            notifica: notifica,
            perfil: '65dccf7ac186b433577b3aef' as any,
        };
    }

    private esEmailValido(email: string): boolean {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    async notificarAprobadosPostRegistro(): Promise<void> {
        try {
            this.flagSpinner = true;
            this.guiMsjService.msjFormSubmit('Enviando');

            const usuariosPayload = [];
            const contenido = this.solicitud.inscripcion
                .contenido as unknown as InscripcionOs;
            const datosTitular = contenido.datosDelTitular;
            const familiares = contenido.familiares || [];

            const sedeTitular = this.usuario.signoSedes && this.usuario.signoSedes[0];
            const sedeCodigoTitular = sedeTitular?.codigoGecro || '000';
            const sedeNombreTitular = sedeTitular?.nombre || 'SEDE NO ESPECIFICADA';

            usuariosPayload.push({
                id: this.solicitud.usuario._id,
                email: this.solicitud.usuario.email,
                nombre: datosTitular.nombre,
                apellido: datosTitular.apellido,
                username: `${datosTitular.nombre}.${datosTitular.apellido}`
                    .toLowerCase()
                    .replace(/\s+/g, ''),
                passwordTemporal: datosTitular.numeroDocumento.toString(),
                notificar: true,
                sedeCodigo: sedeCodigoTitular,
                sedeNombre: sedeNombreTitular,
            });

            for (const familiar of familiares) {
                if (this.familiarOmitido(familiar.numeroDocumento)) {
                    continue;
                }
                if (familiar.email && this.esEmailValido(familiar.email)) {
                    let usuarioFamiliarId = `familiar-${familiar.numeroDocumento}`;
                    let sedeCodigoFamiliar = '000';
                    let sedeNombreFamiliar = 'SEDE NO ESPECIFICADA';
                    try {
                        const usuarioFamiliar = await this.usuarioService.getFindOneByIdentification(
                            familiar.numeroDocumento.toString(),
                        );
                        if (usuarioFamiliar) {
                            usuarioFamiliarId = usuarioFamiliar._id;
                            if (usuarioFamiliar.signoSedes && usuarioFamiliar.signoSedes[0]) {
                                sedeCodigoFamiliar = usuarioFamiliar.signoSedes[0].codigoGecro || '000';
                                sedeNombreFamiliar = usuarioFamiliar.signoSedes[0].nombre || 'SEDE NO ESPECIFICADA';
                            }
                        }
                    } catch (error) { }
                    usuariosPayload.push({
                        id: usuarioFamiliarId,
                        email: familiar.email,
                        nombre: familiar.nombre,
                        apellido: familiar.apellido,
                        username: `${familiar.nombre}.${familiar.apellido}`
                            .toLowerCase()
                            .replace(/\s+/g, ''),
                        passwordTemporal: familiar.numeroDocumento.toString(),
                        notificar: true,
                        sedeCodigo: sedeCodigoFamiliar,
                        sedeNombre: sedeNombreFamiliar,
                    });
                }
            }

            const payload = {
                usuarios: usuariosPayload,
                observacion: `Inscripción aprobada - Solicitud ${this.solicitud._id}`,
                bccAdmin: false,
            };

            const resp: any = await this.solicitudesService.notificarAprobados(payload);
            const data = resp && resp.response ? resp.response : resp;

            Swal.fire({
                icon: 'success',
                title: 'Notificación enviada',
                html: `
                    <div style="text-align:left">
                    <div><b>Total:</b> ${data?.total ?? '-'}</div>
                    <div><b>Notificados:</b> ${data?.notificados ?? '-'}</div>
                    <div><b>Omitidos:</b> ${data?.omitidos ?? '-'}</div>
                    </div>
                `,
            });
        } catch (error) {
            console.error('Error en notificarAprobadosPostRegistro:', error);
            const msg = error?.message || 'Error al enviar la notificación';
            Swal.fire({ icon: 'error', title: 'Ups', text: msg });
        } finally {
            this.flagSpinner = false;
        }
    }

    private async asignarSedeATitular(): Promise<boolean> {
        try {
            const titularGecros = this.resultadosGecros.find(
                (r) => r.tipo === 'Titular' && r.enGecros && r.datosGecros?.data?.length > 0,
            );
            if (!titularGecros) return false;
            const datosGecrosTitular = titularGecros.datosGecros.data[0];
            const numeroAfiliado = datosGecrosTitular.numeroAfiliado;
            if (!numeroAfiliado || numeroAfiliado.length < 3) return false;
            const codigoSede = numeroAfiliado.substring(0, 3);
            const sede = await this.signoSedeService.getSedeByCodigo(codigoSede);
            if (!sede) return false;
            const usuarioActualizado = await this.usuarioService.updateUser(
                this.usuario._id,
                { signoSedes: [sede], perfil: '65dccf7ac186b433577b3aef' as any },
            );
            if (!usuarioActualizado) return false;
            this.usuario.signoSedes = [sede];
            return true;
        } catch (error) {
            console.error('Error al asignar sede al titular:', error);
            return false;
        }
    }

    private async actualizarEmailVerificado(userId: string): Promise<boolean> {
        try {
            const usuarioActualizado = await this.usuarioService.updateUser(userId, { email_verified: true });
            return !!usuarioActualizado;
        } catch (error) {
            return false;
        }
    }

    copiarDNI(dni: string): void {
        navigator.clipboard.writeText(dni).then(() => {
            this.guiMsjService.msjFormSubmit('DNI copiado al portapapeles');
        });
    }

    async guardarObservacionInterna(): Promise<void> {
        try {
            this.flagSpinner = true;
            const respuesta = await this.solicitudesService.updateSolicitudObservacionInterna(
                this.solicitud._id,
                this.solicitud,
                this.observacionInterna,
            );
            if (respuesta) {
                this.solicitud = respuesta;
                this.solicitudesService.setSolicitudSeleccionada(respuesta);
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Observación interna guardada',
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                    toast: true,
                    background: '#28a745',
                    iconColor: 'white',
                });
            }
        } catch (error) {
            console.error('Error al guardar observación interna:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo guardar la observación interna.',
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#dc3545',
            });
        } finally {
            this.flagSpinner = false;
        }
    }

    async habilitarBotonObservacionesInternas(motivo: string) {
        this.habilitarGuardarObservacionInterna = motivo.trim() !== '';
    }

    cerrarModalGecros(): void {
        this.verificacionGecrosModal = false;
        this.familiaresOmitidos = [];
    }

    formatearFecha(fecha: string | Date): string {
        if (!fecha) return 'No especificada';
        return new Date(fecha).toLocaleDateString('es-AR');
    }

    formatearFechaHora(fecha: string | Date): string {
        if (!fecha) return 'No especificada';
        const d = new Date(fecha);
        const dia = d.getDate().toString().padStart(2, '0');
        const mes = (d.getMonth() + 1).toString().padStart(2, '0');
        const anio = d.getFullYear();
        const horas = d.getHours().toString().padStart(2, '0');
        const minutos = d.getMinutes().toString().padStart(2, '0');
        return `${dia}/${mes}/${anio} ${horas}:${minutos}`;
    }

    // Helper para mostrar sexo
    mostrarSexo(sexo: any): string {
        if (typeof sexo === 'number') {
            switch (sexo) {
                case Sexo.Masculino: return 'Masculino';
                case Sexo.Femenino: return 'Femenino';
                default: return 'No especificado';
            }
        } else if (typeof sexo === 'string') {
            return sexo;
        }
        return 'No especificado';
    }

    // Helper para mostrar estado civil
    mostrarEstadoCivil(estado: any): string {
        if (typeof estado === 'number') {
            switch (estado) {
                case EstadoCivil.Soltero: return 'Soltero/a';
                case EstadoCivil.Casado: return 'Casado/a';
                case EstadoCivil.Divorciado: return 'Divorciado/a';
                case EstadoCivil.Viudo: return 'Viudo/a';
                default: return 'No especificado';
            }
        } else if (typeof estado === 'string') {
            return estado;
        }
        return 'No especificado';
    }

    // Helper para mostrar régimen laboral
    mostrarRegimenLaboral(regimen: any): string {
        if (typeof regimen === 'number') {
            switch (regimen) {
                case RegimenLaboral.General: return 'General';
                case RegimenLaboral.Monotributo: return 'Monotributo';
                case RegimenLaboral.ServicioDomestico: return 'Servicio Doméstico';
                default: return 'No especificado';
            }
        } else if (typeof regimen === 'string') {
            return regimen;
        }
        return 'No especificado';
    }

    // Helper para mostrar tipo documento
    mostrarTipoDocumento(tipo: any): string {
        if (typeof tipo === 'number') {
            switch (tipo) {
                case TipoDocumento.DNI: return 'DNI';
                case TipoDocumento.CI: return 'CI';
                case TipoDocumento.LE: return 'LE';
                case TipoDocumento.LC: return 'LC';
                default: return 'No especificado';
            }
        } else if (typeof tipo === 'string') {
            return tipo;
        }
        return 'No especificado';
    }

    // Helper para mostrar nacionalidad
    mostrarNacionalidad(nacionalidad: any): string {
        if (typeof nacionalidad === 'number') {
            switch (nacionalidad) {
                case Nacionalidad.Argentino: return 'Argentino';
                case Nacionalidad.Extranjero: return 'Extranjero';
                default: return 'No especificada';
            }
        } else if (typeof nacionalidad === 'string') {
            return nacionalidad;
        }
        return 'No especificada';
    }

    mostrarFactorRh(factorRh: boolean): string {
        return factorRh ? 'Positivo (+)' : 'Negativo (-)';
    }

    mostrarAntecedentesMedicos(antecedentes: any): string {
        if (!antecedentes) return 'No especificado';
        let info = '';
        if (antecedentes.atencionMedica?.bajoAtencion !== undefined) {
            info += `Bajo atención médica: ${this.mostrarSiNo(antecedentes.atencionMedica.bajoAtencion)}`;
            if (antecedentes.atencionMedica.bajoAtencion) {
                if (antecedentes.atencionMedica.medicoAtiende) info += ` - ${antecedentes.atencionMedica.medicoAtiende}`;
                if (antecedentes.atencionMedica.enfermedad) info += ` - ${antecedentes.atencionMedica.enfermedad}`;
            }
        }
        if (antecedentes.medicamentosUltimos6Meses) {
            if (info) info += ' | ';
            info += `Medicamentos últimos 6 meses: ${antecedentes.medicamentosUltimos6Meses}`;
        }
        if (antecedentes.motivoConsultaActual !== undefined) {
            if (info) info += ' | ';
            info += `Motivo consulta actual: ${this.mostrarSiNo(antecedentes.motivoConsultaActual)}`;
        }
        return info || 'Sin antecedentes médicos relevantes declarados';
    }

    mostrarHabitosFisiologicos(habitos: any): string {
        if (!habitos) return 'No especificado';
        let info = '';
        if (habitos.alimentacion) {
            if (habitos.alimentacion.comidasDiarias !== undefined) {
                info += `Comidas diarias: ${this.mostrarSiNo(habitos.alimentacion.comidasDiarias)}`;
            }
            if (habitos.alimentacion.queAlimentacion) {
                info += info ? ' | ' : '';
                info += `Alimentación: ${habitos.alimentacion.queAlimentacion}`;
            }
            if (habitos.alimentacion.incluyeDesayuno !== undefined) {
                info += info ? ' | ' : '';
                info += `Incluye desayuno: ${this.mostrarSiNo(habitos.alimentacion.incluyeDesayuno)}`;
            }
        }
        if (habitos.sueno) {
            if (info) info += ' | ';
            if (habitos.sueno.suenoTranquilo !== undefined) {
                info += `Sueño tranquilo: ${this.mostrarSiNo(habitos.sueno.suenoTranquilo)}`;
            }
            if (habitos.sueno.horasSueno) {
                info += info.endsWith('Sí') || info.endsWith('No') ? ' ' : ' | ';
                info += `(${habitos.sueno.horasSueno} horas)`;
            }
        }
        if (habitos.constipacion !== undefined) {
            if (info) info += ' | ';
            info += `Constipación: ${this.mostrarSiNo(habitos.constipacion)}`;
        }
        if (habitos.deporte) {
            if (info) info += ' | ';
            if (habitos.deporte.realizaDeporte !== undefined) {
                info += `Realiza deporte: ${this.mostrarSiNo(habitos.deporte.realizaDeporte)}`;
            }
            if (habitos.deporte.cualDeporte) {
                info += info.endsWith('Sí') || info.endsWith('No') ? ' ' : ' | ';
                info += `(${habitos.deporte.cualDeporte})`;
            }
        }
        return info || 'Sin hábitos fisiológicos relevantes declarados';
    }

    mostrarHabitosToxicos(habitos: any): string {
        if (!habitos) return 'No especificado';
        let info = '';
        if (habitos.fumador?.fuma !== undefined) {
            info += `Fuma: ${this.mostrarSiNo(habitos.fumador.fuma)}`;
            if (habitos.fumador.fuma && habitos.fumador.cantidadPorDia) {
                info += ` (${habitos.fumador.cantidadPorDia} por día)`;
            }
        }
        if (habitos.alcohol?.tomaAlcohol !== undefined) {
            if (info) info += ' | ';
            info += `Alcohol: ${this.mostrarSiNo(habitos.alcohol.tomaAlcohol)}`;
            if (habitos.alcohol.tomaAlcohol && habitos.alcohol.cuales) {
                info += ` (${habitos.alcohol.cuales})`;
            }
        }
        if (habitos.drogas?.consumeDrogas !== undefined) {
            if (info) info += ' | ';
            info += `Drogas: ${this.mostrarSiNo(habitos.drogas.consumeDrogas)}`;
            if (habitos.drogas.consumeDrogas && habitos.drogas.cuales) {
                info += ` (${habitos.drogas.cuales})`;
            }
        }
        if (habitos.automedicacion?.seAutomedica !== undefined) {
            if (info) info += ' | ';
            info += `Automedicación: ${this.mostrarSiNo(habitos.automedicacion.seAutomedica)}`;
            if (habitos.automedicacion.seAutomedica && habitos.automedicacion.medicacion) {
                info += ` (${habitos.automedicacion.medicacion})`;
            }
        }
        return info || 'Sin hábitos tóxicos relevantes declarados';
    }

    mostrarAntecedentesGinecoObstetricos(antecedentes: any): string {
        if (!antecedentes) return 'No especificado';
        let info = '';
        if (antecedentes.alteracionesMenstruales?.tiene !== undefined) {
            info += `Alteraciones menstruales: ${this.mostrarSiNo(antecedentes.alteracionesMenstruales.tiene)}`;
            if (antecedentes.alteracionesMenstruales.tiene && antecedentes.alteracionesMenstruales.primeraMenstruacionEdad) {
                info += ` (1ra menstruación: ${antecedentes.alteracionesMenstruales.primeraMenstruacionEdad} años)`;
            }
        }
        if (antecedentes.embarazos?.tuvo !== undefined) {
            if (info) info += ' | ';
            info += `Embarazos: ${this.mostrarSiNo(antecedentes.embarazos.tuvo)}`;
            if (antecedentes.embarazos.tuvo && antecedentes.embarazos.cantidad) {
                info += ` (${antecedentes.embarazos.cantidad})`;
            }
        }
        if (antecedentes.patologiaMamaria?.tiene !== undefined) {
            if (info) info += ' | ';
            info += `Patología mamaria: ${this.mostrarSiNo(antecedentes.patologiaMamaria.tiene)}`;
            if (antecedentes.patologiaMamaria.tiene && antecedentes.patologiaMamaria.cuales) {
                info += ` (${antecedentes.patologiaMamaria.cuales})`;
            }
        }
        return info || 'Sin antecedentes gineco-obstétricos relevantes declarados';
    }

    // Nuevo método para obtener etiqueta
    formatKey(key: string): string {
        return this.fieldLabelMap[key] || key
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, s => s.toUpperCase())
            .trim();
    }

    // Mostrar valor booleano
    mostrarSiNo(valor: boolean): string {
        return valor ? 'Sí' : 'No';
    }

    // Obtener detalle según tipo de objeto
    obtenerDetalle(item: any): string {
        if (!item?.tiene) return '';
        let detalle = item.cual || item.cuales || item.quien || '';
        return detalle;
    }

    // Helpers para contar (ya no se usan en la vista pero se dejan por si acaso)
    contarAntecedentesPatologicos(antecedentes: any): number {
        if (!antecedentes) return 0;
        return Object.values(antecedentes).filter((antecedente: any) => antecedente?.tiene).length;
    }

    contarSintomas(sintomas: any): number {
        if (!sintomas) return 0;
        return Object.values(sintomas).filter((sintoma: any) => sintoma?.tiene).length;
    }

    objectKeys(obj: any): string[] {
        return obj ? Object.keys(obj) : [];
    }

    // ===== DDJJ jerárquica (padre SÍ/NO + hijos anidados) =====
    private siNoItem(label: string, valor: any): DdjjItem {
        return { label, tipo: 'siNo', tiene: !!valor };
    }

    private textoItem(label: string, valor: any): DdjjItem {
        const vacio = valor === null || valor === undefined || valor === '';
        return { label, tipo: 'texto', valor: vacio ? '' : String(valor) };
    }

    private grupoItem(label: string, hijos: DdjjItem[]): DdjjItem {
        return { label, tipo: 'grupo', hijos };
    }

    private mapDdjjItems(obj: any): DdjjItem[] {
        if (!obj) {
            return [];
        }
        return Object.keys(obj).map((key) => {
            const item = obj[key] || {};
            const hijos: DdjjItem[] = [];
            if (item.tiene) {
                if (item.quien) {
                    hijos.push(this.textoItem('Quién', item.quien));
                }
                if (item.cuales) {
                    hijos.push(this.textoItem('Cuáles', item.cuales));
                }
                if (item.cual) {
                    hijos.push(this.textoItem('Cuál', item.cual));
                }
            }
            return {
                label: this.formatKey(key),
                tipo: 'siNo' as 'siNo',
                tiene: !!item.tiene,
                hijos,
            };
        });
    }

    private pushMapSeccion(secciones: DdjjSeccion[], titulo: string, obj: any): void {
        const items = this.mapDdjjItems(obj);
        if (items.length) {
            secciones.push({ titulo, items });
        }
    }

    getDdjjSecciones(): DdjjSeccion[] {
        const ddjj = this.datosInscripcionCompleta && this.datosInscripcionCompleta.ddjj;
        if (!ddjj) {
            return [];
        }

        const secciones: DdjjSeccion[] = [];

        const am = ddjj.antecedentesMedicos;
        if (am) {
            const at = am.atencionMedica || {};
            secciones.push({
                titulo: 'Antecedentes Médicos',
                items: [
                    {
                        label: 'Bajo atención médica',
                        tipo: 'siNo',
                        tiene: !!at.bajoAtencion,
                        hijos: [
                            this.textoItem('Médico que atiende', at.medicoAtiende),
                            this.textoItem('Enfermedad', at.enfermedad),
                            this.textoItem('Cuál enfermedad', at.cualEnfermedad),
                        ],
                    },
                    this.textoItem('Medicamentos (últimos 6 meses)', am.medicamentosUltimos6Meses),
                    this.siNoItem('Motivo de consulta actual', am.motivoConsultaActual),
                ],
            });
        }

        const hf = ddjj.habitosFisiologicos;
        if (hf) {
            const al = hf.alimentacion || {};
            const su = hf.sueno || {};
            const de = hf.deporte || {};
            secciones.push({
                titulo: 'Hábitos Fisiológicos',
                items: [
                    this.grupoItem('Alimentación', [
                        this.siNoItem('Comidas diarias', al.comidasDiarias),
                        this.textoItem('Qué alimentación', al.queAlimentacion),
                        this.siNoItem('Incluye desayuno', al.incluyeDesayuno),
                    ]),
                    this.grupoItem('Sueño', [
                        this.siNoItem('Sueño tranquilo', su.suenoTranquilo),
                        this.textoItem('Horas de sueño', su.horasSueno),
                    ]),
                    this.siNoItem('Constipación', hf.constipacion),
                    this.grupoItem('Deporte', [
                        this.siNoItem('Realiza deporte', de.realizaDeporte),
                        this.textoItem('Cuál deporte', de.cualDeporte),
                    ]),
                ],
            });
        }

        const ht = ddjj.habitosToxicos;
        if (ht) {
            const fu = ht.fumador || {};
            const al = ht.alcohol || {};
            const dr = ht.drogas || {};
            const au = ht.automedicacion || {};
            secciones.push({
                titulo: 'Hábitos Tóxicos',
                items: [
                    this.grupoItem('Fumador', [
                        this.siNoItem('Fuma', fu.fuma),
                        this.textoItem('Desde cuándo', fu.desdeCuando),
                        this.textoItem('Cantidad por día', fu.cantidadPorDia),
                    ]),
                    this.grupoItem('Alcohol', [
                        this.siNoItem('Toma alcohol', al.tomaAlcohol),
                        this.textoItem('Cuáles', al.cuales),
                        this.textoItem('Cuándo', al.cuando),
                        this.textoItem('Cuánto', al.cuanto),
                    ]),
                    this.grupoItem('Drogas', [
                        this.siNoItem('Consume drogas', dr.consumeDrogas),
                        this.textoItem('Cuáles', dr.cuales),
                    ]),
                    this.grupoItem('Automedicación', [
                        this.siNoItem('Se automedica', au.seAutomedica),
                        this.textoItem('Medicación', au.medicacion),
                        this.textoItem('Frecuencia', au.frecuencia),
                    ]),
                ],
            });
        }

        const go = ddjj.antecedentesGinecoObstetricos;
        if (go) {
            const altM = go.alteracionesMenstruales || {};
            const emb = go.embarazos || {};
            const patM = go.patologiaMamaria || {};
            secciones.push({
                titulo: 'Antecedentes Gineco-Obstétricos',
                items: [
                    this.grupoItem('Alteraciones menstruales', [
                        this.siNoItem('Tiene', altM.tiene),
                        this.textoItem('Edad primera menstruación', altM.primeraMenstruacionEdad),
                        this.textoItem('Última menstruación', altM.ultimaMenstruacionFecha),
                    ]),
                    this.grupoItem('Embarazos', [
                        this.siNoItem('Tuvo', emb.tuvo),
                        this.textoItem('Cantidad', emb.cantidad),
                        this.textoItem('Partos normales', emb.partoNormal),
                        this.textoItem('Cesáreas', emb.cesareas),
                        this.textoItem('Abortos', emb.abortos),
                    ]),
                    this.grupoItem('Patología mamaria', [
                        this.siNoItem('Tiene', patM.tiene),
                        this.textoItem('Cuáles', patM.cuales),
                    ]),
                ],
            });
        }

        this.pushMapSeccion(secciones, 'Antecedentes Familiares', ddjj.antecedentesFamiliares);
        this.pushMapSeccion(secciones, 'Antecedentes Patológicos', ddjj.antecedentesPatologicos);
        this.pushMapSeccion(secciones, 'Síntomas y Experiencias', ddjj.sintomasYExperiencias);
        this.pushMapSeccion(secciones, 'Antecedentes Quirúrgicos', ddjj.antecedentesQuirurgicos);

        return secciones;
    }

    // Helper para mostrar parentesco
    mostrarParentesco(parentesco: any): string {
        if (typeof parentesco === 'number') {
            switch (parentesco) {
                case Parentesco.Esposo: return 'Esposo/a';
                case Parentesco.Concubino: return 'Concubino/a';
                case Parentesco.Hijo: return 'Hijo/a';
                default: return 'No especificado';
            }
        } else if (typeof parentesco === 'string') {
            return parentesco;
        }
        return 'No especificado';
    }

    mostrarGrupoSanguineo(grupo: any): string {
        if (typeof grupo === 'string') {
            return grupo;
        }
        return 'No especificado';
    }

    /**
     * Exporta dos PDFs de forma secuencial:
     * 1. PDF de documentación (imágenes y archivos) usando pdf-lib.
     * 2. PDF de Inscripción y DDJJ capturando el div #export-inscripcion-ddjj.
     * Mientras se generan, muestra un spinner fullscreen con el progreso (1 de 2 / 2 de 2).
     */
    async exportarPDFs(): Promise<void> {
        if (this.exportandoPDFs) {
            return;
        }
        if (!this.flagLoaded || !this.solicitud || !this.usuario) {
            return;
        }

        this.exportandoPDFsMensaje = 'Generando PDF 1 de 2 (documentación)...';
        this.exportandoPDFs = true;

        try {
            // --- nombre base para los archivos ---
            const contenido = this.solicitud.inscripcion?.contenido as any;
            const titular = contenido?.datosDelTitular;
            let baseName = `${this.solicitud._nro}`;
            if (titular?.apellido && titular?.nombre) {
                const formatName = (str: string): string =>
                    str.trim().split(/\s+/).map(p => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()).join('-');
                const apellido = formatName(titular.apellido);
                const nombre   = formatName(titular.nombre);
                baseName = `${apellido}-${nombre}-${this.solicitud._nro}`;
            }

            // ----- PDF 1: Documentación (adjuntos) -----
            try {
                await this.pdfExportService.generateAttachmentsPDF(
                    this.solicitud,
                    this.imgs,
                    this.files,
                    this.usuario._id,
                    this.nombresImagenes,
                    `${baseName}-Documentacion.pdf`
                );
            } catch (error) {
                console.error('Error al generar PDF de documentación:', error);
            }

            // ----- PDF 2: Inscripción y DDJJ (múltiples páginas desde el contenedor oculto) -----
            this.exportandoPDFsMensaje = 'Generando PDF 2 de 2 (inscripción y DDJJ)...';
            const contenedor = document.getElementById('export-inscripcion-ddjj-pdf');
            if (!contenedor) {
                console.warn('No se encontró el contenedor oculto para exportar');
                return;
            }

            // Mostramos el contenedor para que html2canvas pueda renderizarlo
            contenedor.style.display = 'block';
            await new Promise(resolve => setTimeout(resolve, 300)); // esperar render

            try {
                const paginas = Array.from(contenedor.querySelectorAll<HTMLElement>('.page-a4'));
                if (paginas.length === 0) {
                    console.warn('No se encontraron páginas .page-a4 dentro del contenedor');
                    return;
                }

                await this.pdfExportService.generateScreenshotsPDF(
                    paginas,
                    `${baseName}-Inscripcion-y-DDJJ.pdf`
                );
            } catch (error) {
                console.error('Error al generar PDF de inscripción:', error);
            } finally {
                contenedor.style.display = 'none';
            }

            this.exportandoPDFsMensaje = '¡Listo! 2 de 2 PDFs generados';
        } finally {
            setTimeout(() => {
                this.exportandoPDFs = false;
                this.exportandoPDFsMensaje = '';
            }, 1200);
        }
    }
}   